import React from "react";
import { GOALS } from "./_shared";

const fmtDate = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" }); }
  catch { return iso; }
};


export default function MealPlanView({ plan }) {
  return (
    <div data-testid="meal-plan-output">
      <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
        <div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#E5B43A] mb-2">// Your Plan</div>
          <h2 className="font-display text-3xl">{GOALS.find(g => g.id === plan.goal)?.label} · {plan.meals?.length || 0} Meals</h2>
        </div>
        <span className="text-xs text-zinc-500">{fmtDate(plan.created_at)}</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {(plan.meals || []).map((m, i) => (
          <div key={`${m.slot}-${m.name}-${i}`} className="border border-zinc-800 bg-[#141414] p-6 hover:border-[#E5B43A] transition-colors flex flex-col" data-testid={`meal-card-${i}`}>
            <div className="flex items-start justify-between mb-2 gap-3">
              <div className="min-w-0 flex-1">
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#E5B43A] mb-1">{m.slot || "Meal"}</div>
                <div className="font-display text-xl leading-tight break-words">{m.name}</div>
              </div>
              {m.prep_time_min ? (
                <div className="shrink-0 border border-zinc-800 px-2 py-1 text-[10px] tracking-widest uppercase text-zinc-400">{m.prep_time_min} min</div>
              ) : null}
            </div>
            {m.flavor_profile && <p className="text-xs text-zinc-400 italic mb-3 break-words">{m.flavor_profile}</p>}
            <div className="flex gap-3 text-[10px] tracking-widest uppercase text-zinc-500 mb-4 pb-3 border-b border-zinc-800">
              <span>{m.calories || "—"} kcal</span><span>·</span><span>{m.protein_g || "—"}g protein</span>
            </div>
            {m.ingredients?.length > 0 && (
              <div className="mb-4">
                <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-2">Ingredients</div>
                <ul className="text-sm text-zinc-300 space-y-1">
                  {m.ingredients.map((ing) => <li key={ing} className="flex gap-2"><span className="text-[#E5B43A] shrink-0">·</span><span className="break-words min-w-0">{ing}</span></li>)}
                </ul>
              </div>
            )}
            {m.instructions?.length > 0 && (
              <div className="mb-4">
                <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-2">Cooking Steps</div>
                <ol className="text-sm text-zinc-200 space-y-2 leading-relaxed">
                  {m.instructions.map((step, j) => (
                    <li key={`${m.name}-step-${j}`} className="flex gap-3"><span className="font-display text-[#E5B43A] shrink-0">{j + 1}.</span><span className="break-words min-w-0">{step.replace(/^Step\s*\d+:\s*/i, "")}</span></li>
                  ))}
                </ol>
              </div>
            )}
            {m.notes && <p className="text-xs text-zinc-500 italic border-t border-zinc-800 pt-3 mt-auto break-words">💡 {m.notes}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
